import { render, staticRenderFns } from "./cadastroViagem.vue?vue&type=template&id=4d5dad77&scoped=true"
import script from "./cadastroViagem.vue?vue&type=script&lang=js"
export * from "./cadastroViagem.vue?vue&type=script&lang=js"
import style0 from "./cadastroViagem.vue?vue&type=style&index=0&id=4d5dad77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5dad77",
  null
  
)

export default component.exports